module.exports = __webpack_public_path__ + "static/media/case_10.98e9ec2b.jpg";